import React from 'react'

import './style.scss'
import changelog from '../../../../data/changelog.json'

const Changelog = props => {
  let fullChangelog = Object.entries(changelog)

  let versions = props.versions

  return (
    <>
      {versions
        .sort()
        .reverse()
        .map(ver => (
          <div>
            <h2>Version {ver}</h2>
            {fullChangelog
              .filter(e => e[1].changelog[ver])
              .map(item => (
                <div>
                  <h4>{item[0]}</h4>
                  <h5>{item[1].changelog[ver].date}</h5>
                  <ul>
                    {item[1].changelog[ver].notes.map(log => (
                      <li>{log}</li>
                    ))}
                  </ul>
                </div>
              ))}
          </div>
        ))}
    </>
  )
}

Changelog.defaultProps = {
  versions: ['1.1.0'],
}

export default Changelog
